import Nullstack from 'nullstack';
export default function IconGenderThird({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-gender-third",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M11 12a5 5 0 1 0 10 0a5 5 0 0 0 -10 0z"
  }), "   ", Nullstack.element("path", {
    d: "M11 12h-3"
  }), "   ", Nullstack.element("path", {
    d: "M8 12l-5 -4v8z"
  }), " ");
}